/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {

  fetchRatings({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/theoryratings", data)
        .then((response) => {
          commit('SET_RATINGS', response.data)
          commit('SET_RATINGS_COUNT', response.data.length)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchRating1Avg({ commit }) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/theoryratingsavg", {
        "column": "rating1"
      })
        .then((response) => {
          commit('SET_RATINGS1', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchRating2Avg({ commit }) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/theoryratingsavg", {
        "column": "rating2"
      })
        .then((response) => {
          commit('SET_RATINGS2', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchRating3Avg({ commit }) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/theoryratingsavg", {
        "column": "rating3"
      })
        .then((response) => {
          commit('SET_RATINGS3', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  searchRatings({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/theoryratings", data)
        .then((response) => {
          commit('SET_RATINGS', response.data)
          commit('SET_RATINGS_COUNT', response.data.length)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  
}
